var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer-legend"},[_c('img',{staticClass:"layer-legend__image",attrs:{"src":_vm.legendUrl,"alt":"legend"}})])}
var staticRenderFns = []

export { render, staticRenderFns }